import React from "react";
import blackapp from "../../../../assets/blackapp.svg";
import downloadphone from "../../../../assets/downloadphone.png";
import blackpay from "../../../../assets/blackgpay.svg";
import { Link } from "react-router-dom";
import "./Download.scss";
function DownloadSuperApp({appStoreLink, playStoreLink}) {
  return (
    <div className="downsuperapp container">
      <div className="downsuperapp_left">
        <h2>
          Triskel Wallet.
          <br /> The Ultimate Web3 Super&nbsp;App
        </h2>
        <div className="downsuperapp_left_buttons">
          <Link target="_blank" to={appStoreLink}>
            <img src={blackpay} alt="imgs" />
          </Link>
          <Link ttarget="_blank" to={playStoreLink}>
            <img src={blackapp} alt="imgs" />
          </Link>
        </div>
      </div>
      <div className="downsuperapp_right">
        <img src={downloadphone} alt="imgs" />
      </div>
    </div>
  );
}

export default DownloadSuperApp;
